const PorfileNavIcon = ({
  className = 'stroke-green-800'
}: {
  className?: string
  fill?: string
}) => (
  <svg
    width='24'
    height='27'
    viewBox='0 0 24 27'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M14.8171 4.60233C16.373 6.32081 16.373 9.10701 14.8171 10.8255C13.2613 12.544 10.7387 12.544 9.18288 10.8255C7.62703 9.10701 7.62703 6.32081 9.18288 4.60233C10.7387 2.88386 13.2613 2.88386 14.8171 4.60233'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12 15.4722C16.554 15.4722 21 17.6448 21 20.986V22.0905C21 22.7002 20.552 23.195 20 23.195H4C3.448 23.195 3 22.7002 3 22.0905V20.986C3 17.6437 7.446 15.4722 12 15.4722'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default PorfileNavIcon
